import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Container, Button, Typography, Paper, CircularProgress, Alert, Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';

axios.defaults.withCredentials = true;

function ManageUserPage() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null); // For current logged-in user's role

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const statusResponse = await axios.get('/api/users/status');
        if (statusResponse.data.loggedIn && statusResponse.data.user.role === 'admin') {
          setUserRole('admin');
          const userResponse = await axios.get(`/api/users/${userId}`);
          setUser(userResponse.data);
          setSelectedRole(userResponse.data.role);
        } else {
          setMessage('Access Denied: You must be an admin to view this page.');
        }
      } catch (error) {
        setMessage('Error fetching user data: ' + (error.response?.data || error.message));
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [userId]);

  const handleRoleChange = async () => {
    try {
      const response = await axios.put(`/api/users/${userId}/role`, { role: selectedRole });
      setMessage(response.data.message);
    } catch (error) {
      setMessage('Error updating role: ' + (error.response?.data || error.message));
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (userRole !== 'admin') {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Alert severity="error">{message}</Alert>
      </Container>
    );
  }

  if (!user) {
    return <Typography>User not found.</Typography>;
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Manage User: {user.username}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Role: {user.role}
        </Typography>
        <Box sx={{ mt: 3 }}>
          <FormControl fullWidth>
            <InputLabel id="role-select-label">Change Role</InputLabel>
            <Select
              labelId="role-select-label"
              value={selectedRole}
              label="Change Role"
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <MenuItem value="racer">Racer</MenuItem>
              <MenuItem value="photographer">Photographer</MenuItem>
              <MenuItem value="director">Director</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
          <Button variant="contained" color="primary" onClick={handleRoleChange} sx={{ mt: 2 }}>
            Update Role
          </Button>
        </Box>
        {message && <Alert severity={message.includes('Error') ? 'error' : 'success'} sx={{ mt: 2 }}>{message}</Alert>}
      </Paper>
    </Container>
  );
}

export default ManageUserPage;
